<app-http-error
[header]="'HTTP_ERROR.404.HEADER'"
[body]="'HTTP_ERROR.404.BODY'"
[http-error]="'404'"
></app-http-error>

